import { forwardRef } from "react";
import { styled } from "styled-components";

/* url(${FirstBackground}) no-repeat 30% 80%;*/
const BannerImage = styled.div`
  position: absolute;
  display: inline-block;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: url(${(props) => props.$background_image})
    ${(props) => props.$background_image_details};
  min-height: 100%;
  background-size: cover;
  z-index: -1;

  transition: transform 2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    background: url(${(props) =>
        props.$mobile_background_image || props.$background_image})
      ${(props) => props.$background_image_details};
    background-size: cover;
  }
`;

const BannerWithProps = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: repeat(auto-fill, 10%);
  grid-template-columns: repeat(auto-fill, 5%);
  width: 100%;
  height: 100vh;
  min-height: 100%;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  overflow: hidden;
  z-index: 1;
`;

const Banner = forwardRef(
  (
    {
      className,
      imageRef,
      background_image,
      mobile_background_image,
      background_image_details,
      children,
    },
    ref
  ) => {
    return (
      <BannerWithProps className={className} ref={ref}>
        {children}
        <BannerImage
          className={"main_image"}
          ref={imageRef}
          $background_image={background_image}
          $mobile_background_image={mobile_background_image}
          $background_image_details={background_image_details}
        />
      </BannerWithProps>
    );
  }
);

export default Banner;
